import getOption from './getOption';
/**
 *  return the option have the selected value from all options of the facet selection.
 * If we don't have selected value we will use first option is All/Any option as the selected option.
 * When no the option match to the selected value, we will fallback to the current selected option.
 * @param {*} newValue the new selected value from user
 * @param {*} currentOption the current selected option
 * @param {*} options all options of the facet selection
 */

export default function getOptions(newValue, currentOption, options) {
	const newOption = getOption(newValue, options);

	if (newOption) {
		return newOption;
	}

	return currentOption;
}
